import {Button, IconButton, Stack, styled} from '@mui/material'
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward'
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
import {useI18n} from 'store/Store'
import {useIsMobile} from 'services/hooks/use-mobile'

const DanceItemControls = ({
    index,
    isFirst,
    isLast,
    handleMoveDance,
    handleRemoveDance,
    showRemove = true,
    moveUpLabel = 'danceCollections.moveUp',
    moveDownLabel = 'danceCollections.moveDown',
    removeLabel = 'danceCollections.removeDance',
}) => {
    const {i18n} = useI18n()
    const isMobile = useIsMobile()

    const buttons = [
        {
            key: 'moveUp',
            variant: 'outlined',
            label: i18n.t(moveUpLabel),
            icon: <ArrowUpwardIcon fontSize="small" />,
            disabled: isFirst,
            onClick: () => handleMoveDance(index, index - 1),
        },
        {
            key: 'moveDown',
            variant: 'outlined',
            label: i18n.t(moveDownLabel),
            icon: <ArrowDownwardIcon fontSize="small" />,
            disabled: isLast,
            onClick: () => handleMoveDance(index, index + 1),
        },
        {
            key: 'remove',
            variant: 'contained',
            label: i18n.t(removeLabel),
            icon: <DeleteOutlineIcon />,
            onClick: () => handleRemoveDance(index),
        },
    ]

    return (
        <Container direction="row" spacing={isMobile ? 0 : 1}>
            {buttons.map((button) => {
                return isMobile ? (
                    <IconButton
                        key={button.key}
                        onClick={button.onClick}
                        color="primary"
                        size="small"
                        disabled={button.disabled}>
                        {button.icon}
                    </IconButton>
                ) : (
                    <Button
                        key={button.key}
                        variant={button.variant}
                        color="primary"
                        disabled={button.disabled}
                        onClick={button.onClick}
                        startIcon={button.icon}>
                        {button.label}
                    </Button>
                )
            })}

            {/* <Button
                variant="outlined"
                color="primary"
                disabled={isFirst}
                onClick={() => handleMoveDance(index, index - 1)}
                startIcon={<ArrowUpwardIcon fontSize="small" />}>
                {i18n.t(moveUpLabel)}
            </Button>

            <Button
                variant="outlined"
                color="primary"
                disabled={isLast}
                onClick={() => handleMoveDance(index, index + 1)}
                startIcon={<ArrowDownwardIcon fontSize="small" />}>
                {i18n.t(moveDownLabel)}
            </Button>

            {showRemove && (
                <Button
                    variant="contained"
                    color="error"
                    onClick={() => handleRemoveDance(index)}
                    startIcon={<DeleteOutlineIcon />}>
                    {i18n.t(removeLabel)}
                </Button>
            )} */}
        </Container>
    )
}

export default DanceItemControls

const Container = styled(Stack)`
    /* & > :not(style) ~ :not(style) {
        margin-left: 0;
    } */

    & > button {
        justify-content: flex-start;
        gap: 8px;
    }
`
